<template>
    <div>
        <h1>
            Coupons
            <router-link :to="{ name: 'create-coupon' }" tag="button" type="button" class="btn btn-sm btn-primary">
                Create
            </router-link>
        </h1>

        <div class="alert alert-danger" v-if="error">
            <p class="mb-0">
                {{ error }}
            </p>
        </div>

        <datatable class="mt-4" :cols="columns" :rows="coupons.filter((c) => c.deleted_at == null)" />
    </div>
</template>
  
<script>
import store from "../../../store";
import { mapState } from "vuex";
import DataTable from "../../DataTable";
import { createDatatableButtons, getError } from "../../../helpers";

export default {
    components: {
        datatable: DataTable,
    },

    data() {
        return {
            name: null,
            error: null,

            columns: [
                {
                    headerName: "ID",
                    field: "id",
                    sortable: true,
                    filter: true,
                    resizable: true,
                    minWidth: 50,
                    maxWidth: 75,
                },
                {
                    headerName: "Code",
                    field: "code",
                    sortable: true,
                    filter: true,
                    resizable: true,
                    minWidth: 150,
                },
                {
                    headerName: "Discount",
                    field: "discount",
                    sortable: true,
                    filter: true,
                    resizable: true,
                    minWidth: 150,
                },
                {
                    headerName: "End Date",
                    field: "endDate",
                    sortable: true,
                    filter: true,
                    resizable: true,
                    minWidth: 150,
                },
                {
                    headerName: "Active",
                    field: "active",
                    sortable: true,
                    filter: true,
                    resizable: true,
                    minWidth: 150,
                },
                {
                    headerName: "Actions",
                    field: "id",
                    minWidth: 175,
                    maxWidth: 175,

                    cellRenderer: (params) => {
                        const buttons = [];

                        buttons.push({
                            name: params.data.active ? 'Unactive' : 'Active',
                            type: 'info',
                            handler: () => {
                                if (confirm('Are you sure you want to set toggle to active this coupon?')) {
                                    this.error = null;

                                    this.$store.dispatch('coupons/active', { couponId: params.value, active: !params.data.active })
                                        .catch(e => {
                                            this.error = getError(e);
                                        });
                                }
                            },
                        });
                        buttons.push({
                            name: "Edit",
                            type: "secondary",
                            handler: () => {
                                this.$router.push({
                                    name: "edit-coupon",
                                    params: {
                                        id: params.value,
                                    },
                                });
                            },
                        });

                        buttons.push({
                            name: "Delete",
                            type: "danger",
                            handler: () => {
                                if (
                                    confirm(
                                        `Are you sure you want to delete this coupon entry?`
                                    )
                                ) {
                                    this.error = null;

                                    this.$store
                                        .dispatch('coupons/delete', {
                                            couponId: params.value
                                        })
                                        .catch((e) => {
                                            this.error = getError(e);
                                        });
                                }
                            },
                        });
                        return createDatatableButtons(buttons);
                    },
                },
            ],
        };
    },

    computed: {
        ...mapState({
            coupons: state => state.coupons.coupons.map((a) => ({ ...a })),
        }),
    },

    async beforeRouteEnter(to, from, next) {
        await store.dispatch("coupons/fetchAll");
        next();
    },

    meta: {
        title: "Coupons",

        meta: [{ property: "og:title", content: "Coupons / Shayah" }],
    },
};
</script>
  
<style scoped>

</style>